export default {
    app: {
        name:     'Group',
        product:  'Imprion PMS',
        subtitle: 'chain console',
    },

    general: {
        cancel:             'Cancel',
        close:              'Close',
        confirm:            'Confirmation',
        delete:             'Delete',
        edit:               'Edit',
        hint:               'Explanation',
        loading:            'Loading …',
        remove:             'Remove',
        no:                 'No',
        no_data:            'No data',
        no_match:           'No matches',
        not_ready:          'This view is not available yet',
        not_ready_hint:     'The service does not carry this route yet. The screen draws itself once it ships.',
        open_in_reception:  'Open reception',
        pick_date:          'Pick a date',
        save:               'Save',
        select_confirm:     'Confirm',
        selected_count:     'selected: {count}',
        try_again:          'Try again',
        yes:                'Yes',
    },

    errors: {
        already_exists:   'The record already exists',
        confirm_moved_on: 'The action was cancelled — another record was opened in the meantime',
        forbidden:        'You are not allowed to do this',
        generic_error:    'Something went wrong',
        invalid_data:     'Invalid data',
        load_failed:      'The data could not be read',
        not_found:        'Not found',
        on_add:           'Could not add',
        on_delete:        'Could not delete',
        on_edit:          'Could not save',
        on_load:          'Could not read the data',
        open_failed:      'The reception portal could not be opened',
        popup_blocked:    'The browser refused a new tab. Allow pop-ups for this site.',
        session_expired:  'The session has expired, sign in again',
        unauthorized:     'You are not allowed to do this',
    },

    validation: {
        bic:      'A BIC is 8 or 11 characters',
        country:  'A country code is two letters (SI)',
        currency:      'A currency code is three letters (EUR)',
        rate_positive: 'The rate has to be greater than zero',
        sections_required: 'Add at least one section',
        required: 'This field is required',
        too_long: 'This is too long',
        weekdays_required: 'Pick at least one day',
    },

    nav: {
        campaigns:     'Campaigns',
        accounting:    'Accounting',
        alerts:        'Alerts',
        budgets:       'Budget',
        channels:      'Channels',
        contracts:     'Contracts',
        entities:     'Companies',
        fx:            'Exchange rates',
        group_section: 'Group',
        intercompany:  'Intercompany',
        language:     'Language',
        language_en:  'English',
        language_sl:  'Slovenian',
        marketing_roi: 'ROI',
        materials:     'Procurement',
        loans:         'Loans',
        master_groups: 'Master groups',
        logout:       'Sign out',
        menu:         'Menu',
        month_close:   'Month close',
        milo:          'Milo',
        operations:    'Operations log',
        overview:     'Overview',
        payroll:       'Payroll',
        people:        'People',
        pickup:        'Pickup',
        pnl:            'Statement',
        rate_templates: 'Rates',
        staff:          'People KPI',
        reports:       'Reports',
        reservations:  'Reservations',
        structure:    'Structure',
        theme:        'Theme',
        theme_dark:   'Dark',
        theme_light:  'Light',
        theme_system: 'System',
    },

    login: {
        demo_signing_in: 'Signing in …',
        demo_failed: 'This server has no such role.',
        failed:   'Wrong username or password',
        password: 'Password',
        submit:   'Sign in',
        title:    'Sign in to the chain console',
        username: 'Username',
    },

    scope: {
        covers:          'Scope — houses: {count}',
        kind_entity:     'One company',
        kind_group:      'The whole group',
        kind_properties: 'Picked houses',
        kind_unit:       'Region or brand',
        label:           'Scope',
        pick_entity:     'Pick a company',
        pick_properties: 'Pick the houses',
        pick_unit:       'Pick a unit',
        picked:          'Houses picked: {count}',
    },

    // When an account holds no group right at all — one sentence instead of an empty
    // board with a red box on it (docs/PRAVICE_IN_OBSEG.md §5).
    no_access: {
        description: 'Your account holds no head-office right, so there is no screen in this console it may open. An administrator grants one in the reception portal, under Settings → Roles.',
        sign_out:    'Sign out',
        title:       'No access to the head office',
    },

    overview: {
        no_houses: 'No houses in this scope',
        title:     'Overview',
    },

    /**
     * The one line every consolidated board carries under its tiles.
     * `components/ConsolidationNote.vue`.
     */
    consolidation: {
        as_of:  'captured at {time}',
        houses: '{included} of {total} houses included',
        rate:   'rate for {month}',
    },

    age: {
        just_now:    'just now',
        days_one:    '{count} day',
        days_two:    '{count} days',
        days_few:    '{count} days',
        days_other:  '{count} days',
        hours_one:   '{count} hour',
        hours_two:   '{count} hours',
        hours_few:   '{count} hours',
        hours_other: '{count} hours',
    },

    flash: {
        change_vs_last_year:  '{change} against last year (MTD)',
        column_adr:           'ADR',
        column_arrivals:      'Arrivals',
        column_company:       'Company',
        column_house:         'House',
        column_in_house:      'In house',
        column_mtd:           'MTD against last year',
        column_occupancy:     'Occupancy',
        column_revpar:        'RevPAR',
        column_room_revenue:  'Room revenue',
        column_rooms:         'Rooms',
        column_status:        'Status',
        excluded_hint:        'The service left these houses out of the group total.',
        excluded_title:       'Excluded houses',
        in_house_hint:        '{arrivals} arrivals · {departures} departures · {noShows} no-shows',
        legend_closed:        'closed',
        legend_currency:      '{currency} is the report currency · foreign currencies at the monthly rate ({month})',
        legend_missing:       'missing from the total',
        live_failed:          'the live figures could not be read',
        next_day:             'Next day',
        no_company:           'no company',
        no_last_year:         'no comparison with last year',
        no_rate_short:        'no rate',
        no_rows:              'Nothing for this day',
        pill_missing:         'houses with no night audit: {count}',
        pill_no_company:      'houses with no company: {count}',
        pill_rate:            '{currency} {rate} · {month}',
        points_vs_last_year:  '{points} pts against last year (MTD)',
        previous_day:         'Previous day',
        status_closed:        'closed',
        status_closed_at:     'closed {time}',
        status_missing:       'the night audit did not run',
        status_no_rate:       'no rate',
        subtitle:             'the daily flash across the houses',
        table_title:          'By house',
        tile_adr:             'ADR',
        tile_in_house:        'In house today',
        tile_mtd_revenue:     'Room revenue MTD',
        tile_occupancy:       'Occupancy',
        tile_revpar:          'RevPAR',
        tile_rooms_sold:      'Rooms sold',
        tile_rooms_sold_hint: 'houses closed: {closed} of {total}',
        today:                'today',
        total_missing:        'houses missing: {count}',
        total_row:            'Group ({counted} of {total} houses)',
    },

    payroll: {
        blocked:              'A month is not closed: {houses} ({count} houses). Close it in the house or switch on Draft.',
        blocked_unreadable:   'One of the houses could not be read. Try again or switch on Draft.',
        column_absence:       'Absence',
        column_balance:       'Balance',
        column_closed_at:     'Closed',
        column_department:    'Department',
        column_employee_no:   'Employee no.',
        column_expected:      'Expected',
        column_hash:          'Hash',
        column_house:         'House',
        column_name:          'Name',
        column_payroll_code:  'Payroll code',
        column_rows:          'Rows',
        column_status:        'Status',
        column_version:       'Version',
        column_worked:        'Worked',
        company:              'Company',
        company_chip:         'Company code: {code}',
        download:             'Download CSV',
        download_hint:        'Downloads the file for accounting (CSV, UTF-8)',
        draft:                'Draft',
        draft_badge:          'Draft',
        draft_hint:           'allow downloading months that are not closed yet',
        excluded_title:       'Excluded houses',
        final:                'Closed',
        home_property:        'home house: {house}',
        house_unreadable:     'The month of {house} could not be read',
        houses_hint:          'One row is one house. An open or reopened month stops a closed file.',
        houses_title:         'Houses in the file',
        legend_balance:       'Balance is worked + absence − expected. It is not overtime.',
        legend_blocking:      'Tinted row: this house has not closed its month.',
        legend_hash:          'The hash is the fingerprint of the house\'s closed month.',
        legend_mismatch:      'Tinted row: the person\'s home house is owned by another company.',
        mismatch_badge:       'Other company',
        mismatch_tooltip:     'this person\'s home house is owned by another company',
        mixed_settings:       'Mixed settings',
        mixed_settings_hint:  'The houses of this file do not spell quantities alike. The file uses the first house\'s settings.',
        month:                'Month',
        no_companies:         'The register holds no active company',
        no_rows:              'No person of this company worked in this month',
        no_houses:            'No house of this company has a month here',
        rows_hint:            'One row is one person in one house. Somebody who worked in two houses has two rows.',
        rows_title:           'Payroll rows',
        status_closed:        'Closed',
        status_missing:       'No record',
        status_open:          'Open',
        status_reopened:      'Reopened',
        subtitle:             'the wage run by company, across the whole group',
        tile_balance:         'Balance',
        tile_balance_hint:    'worked + absence − expected',
        tile_houses:          'Houses',
        tile_houses_hint:     'not closed: {count}',
        tile_people:          'People',
        tile_people_hint:     '{count} rows',
        tile_worked:          'Worked',
        tile_worked_hint:     'expected: {value}',
        title:                'Payroll',
        total_row:            'Total ({count} people)',
    },

    people: {
        account_inactive:        'account is not active',
        basis_agency_worker:     'Agency worker',
        basis_copyright_contract: 'Copyright contract',
        basis_employment_contract: 'Contract of employment',
        basis_other:             'Other',
        basis_pensioner_temporary: 'Temporary work of a pensioner',
        basis_self_employed:     'Self-employed',
        basis_service_contract:  'Service contract',
        basis_short_term_family_work: 'Short-term family work',
        basis_student_work:      'Student work',
        basis_traineeship:       'Traineeship',
        capped:                  'This is the first part of the register',
        capped_hint:             'The answer is limited to 2000 rows. Narrow the scope, the day or the search to see the rest.',
        column_basis:            'Basis',
        column_company:          'Company',
        column_department:       'Department',
        column_home:             'Home house',
        column_name:             'Name',
        column_period:           'Valid',
        column_position:         'Post',
        column_time:             'Time',
        column_works_in:         'Works in',
        company_all:             'All companies',
        company_chip:            '{name}: {count}',
        company_filter:          'Company',
        fix_company:             'Correct the company',
        fix_company_confirm:     'Move {person}\'s contract to {company}? This decides who files their payroll.',
        fix_company_saved:       'The contract is now held by {company}',
        house_unreadable:        'The codebook of {house} could not be read',
        legend_mismatch:         'A tinted row: the contract is held by a company other than the house\'s.',
        legend_row:              'Click a row to open that person\'s periods.',
        mismatch_badge:          'Another company',
        mismatch_tooltip:        'the contract is held by a company other than the house\'s',
        no_company:              'No company',
        no_people:               'Nobody works in this scope on that day',
        no_periods:              'This person has no periods of work',
        on_day:                  'On',
        open_period:             'open',
        open_personnel:          'Open the personnel card',
        open_personnel_hint:     'Opens the personnel card in the home house\'s reception portal',
        outside_scope:           'outside your scope',
        person_title:            'Person',
        search_placeholder:      'Name, username or employee number',
        subtitle:                'who works in the group, and for which company',
        table_hint:              'One row is one person. Somebody working two houses is one contract naming two houses.',
        table_title:             'Register of people',
        tile_mismatches:         'Mismatches',
        tile_mismatches_hint:    'contract held by a company other than the house\'s',
        tile_people:             'People',
        tile_people_hint:        'home houses: {count}',
        tile_without_company:    'No company',
        tile_without_company_hint: 'the contract is held by no company',
        time_full_time:          'Full time',
        time_part_time:          'Reduced time',
        title:                   'People',
    },

    loans: {
        add:                        'New loan',
        add_hint:                   'Lend a person to another house of the group for a stated period.',
        add_title:                  'New loan',
        added:                      'The loan is recorded',
        badge_intercompany:         'Between companies',
        badge_same_company:         'Same company',
        cancel_confirm:             'Cancel the loan of {person} to {house}? It has not started, so it will not happen.',
        cancel_failed:              'The loan could not be cancelled',
        cancel_hint:                'Cancels a loan that has not started',
        cancel_reason_default:      'Withdrawn by the head office.',
        cancelled_toast:            'The loan of {person} has been cancelled',
        capped:                     'Only the first part of the register is shown',
        capped_hint:                'The answer is capped at 2000 rows. Narrow the scope or the month to see the rest.',
        column_cost_centre:         'Cost centre',
        column_department:          'Department',
        column_from_house:          'From house',
        column_hours:               'Hours',
        column_loans:               'Loans',
        column_people:              'People',
        column_period:              'Period',
        column_person:              'Person',
        column_relation:            'Relation',
        column_status:              'Status',
        column_to_house:            'To house',
        departments_failed:         'That house\'s departments could not be read',
        edit_hint:                  'Correct the period, the department or the cost centre. The person and the house cannot be changed.',
        edit_title:                 'Correct the loan',
        end:                        'End',
        end_hint:                   'Ends a running loan — the last day moves to today',
        field_cost_centre:          'Cost centre',
        field_cost_centre_hint:     'Empty means the receiving department\'s own centre. What you type is an exception for this loan and is frozen on it.',
        field_cost_centre_placeholder: 'as the department books',
        field_department:           'Department in the receiving house',
        field_department_hint:      'An entry of the receiving house\'s codebook. The person stands under it on that house\'s rota.',
        field_department_placeholder: 'Pick a department',
        field_from:                 'From',
        field_person:               'Person',
        field_person_hint:          'Searches the name, the username and the employee number. The lending house is this person\'s home house.',
        field_person_placeholder:   'Find a person',
        field_reason:               'Reason',
        field_reason_hint:          'Why this person is lent. Not required, and the only thing that explains this row six months later.',
        field_to:                   'To',
        field_to_hint:              'The last day of the loan, inclusive. A loan with no end is not a loan.',
        field_to_property:          'To house',
        field_to_property_hint:     'The house receiving the person. The hours are recorded there.',
        field_to_property_placeholder: 'Pick a house',
        house_unreadable:           'The data of {house} could not be read',
        intercompany_tooltip:       'the two houses belong to different companies',
        legend_hours:               'Hours worked in the receiving house inside the loan\'s window. Zero without the time module.',
        legend_intercompany:        'Tinted row: the two houses belong to different companies.',
        legend_summary:             'One row is one direction between two houses. No amounts: the intercompany invoice is a package of its own.',
        month:                      'Month',
        no_company:                 'No company',
        no_loans:                   'No loans in this month within this scope',
        no_pairs:                   'No loans between houses in this month',
        open_rota:                  'Open rota',
        open_rota_hint:             'Opens the rota in the receiving house\'s reception portal',
        saved:                      'The loan has been corrected',
        status:                     'Status',
        status_active:              'Running',
        status_all:                 'All statuses',
        status_cancelled:           'Cancelled',
        status_ended:               'Ended',
        status_planned:             'Planned',
        subtitle:                   'who of our people is working in another house of the group',
        summary_hint:               'One row is one direction: the lending house and the receiving one. The basis for intercompany billing.',
        summary_title:              'Summary by pairs',
        table_hint:                 'One row is one loan. The hours come from the receiving house\'s record and are moved nowhere.',
        table_title:                'Loans this month',
        tile_hours:                 'Hours in other houses',
        tile_hours_hint:            'inside the loan windows',
        tile_intercompany:          'Between companies',
        tile_intercompany_hint:     'loans crossing a taxpayer boundary',
        tile_loans:                 'Loans',
        tile_people:                'People',
        tile_people_hint:           'one person may be lent more than once',
        title:                      'Loans',
        total_row:                  'Total',
    },

    pickup: {
        column_house:   'House',
        horizon:        'Horizon',
        horizon_months: 'next {count} months',
        legend_nights:  'the top figure is room nights on the books (OTB)',
        legend_revenue: 'the bottom figure is revenue in {currency}',
        no_data:        'Nothing on the books for this horizon',
        subtitle:       'what is already on the books',
        table_hint:     'On the books, month by month. No forecast and no budget.',
        table_title:    'By house and month',
        title:          'Pickup',
        total_row:      'Group (houses: {count})',
    },

    budget: {
        column_house:              'House',
        copied:                    'Carried forward from {from} to {to}: {count} cells',
        copy:                      'Copy to next year',
        copy_all_metrics:          'all metrics',
        copy_factor:               'Factor (%)',
        copy_factor_hint:          '100 means the same again, 105 five per cent more.',
        copy_from_year:            'From year',
        copy_hint:                 'Every month of every metric of the houses in scope is written into the target year. A second press replaces the first rather than scaling twice.',
        copy_metrics:              'Metrics',
        copy_metrics_hint:         'Empty means all of them. Occupancy is usually left out — a hotel has not gained five per cent more rooms.',
        copy_title:                'Carry the budget into another year',
        copy_to_year:              'To year',
        excluded_hint:             'The service left these months out of the group total.',
        excluded_months:           'months: {months}',
        excluded_title:            'Excluded months',
        legend_converted:          'the second line is the conversion into {currency} at the month rate',
        legend_house_currency:     'typed in the house currency (the code is in the row header)',
        legend_no_group_occupancy: 'the group has no planned occupancy: an average of house ratios is not a figure',
        legend_no_rate:            'a month with no rate — money cannot be expressed and is out of the total',
        legend_stack:              'plan on top, actual in the middle, variance below',
        metric:                    'Metric',
        metric_fnb_revenue:        'Food and beverage',
        metric_occupancy_bp:       'Occupancy',
        metric_other_revenue:      'Other revenue',
        metric_room_revenue:       'Room revenue',
        metric_rooms_sold:         'Room nights sold',
        metric_total_revenue:      'Total revenue',
        no_actual:                 'no actual',
        no_data:                   'Nothing for this year',
        no_plan:                   'no plan',
        no_rate:                   'no rate',
        save:                      'Save ({count})',
        saved:                     'Cells saved: {count}',
        saving_hint:               'The grid is locked while a save is out, so nothing typed into it is lost.',
        subtitle:                  'what we promised, and how it is going',
        table_actual:              '{metric} — budget against actual',
        table_actual_hint:         'By house and month, in the report currency. The total covers only months with both a plan and an actual.',
        table_plan:                '{metric} — budget',
        table_plan_hint:           'The plan by house and month. Typed in the house currency, read in the report currency.',
        title:                     'Budget',
        total_row:                 'Group (houses: {count})',
        view:                      'View',
        view_actual:               'Budget against actual',
        view_plan:                 'Budget',
        year:                      'Year',
    },


    pnl: {
        chart_cost:                'Known costs',
        chart_hint:                'The group by month. The margin is drawn only where both costs were read.',
        chart_margin:              'Margin',
        chart_no_margin:           'No margin can be computed yet: the labour cost has not been read for these months.',
        chart_revenue:             'Revenue',
        chart_title:               'Trend (12 months)',
        column_company:            'Company',
        column_group:              'Group',
        column_house:              'House',
        column_labour:             'Labour',
        column_margin:             'Margin',
        column_margin_share:       'Margin %',
        column_materials:          'Materials',
        column_per_night:          'Per room night',
        column_plan:               'Budget',
        column_revenue:            'Revenue',
        column_status:             'Status',
        eliminations_hint:         'The margin the group charged itself when goods crossed a company line.',
        eliminations_in_rows:      'Taken off the materials cost in the group row and in the total.',
        eliminations_invoices:     'from {count} issued invoices',
        eliminations_no_rate:      'Invoices with no rate for the month: {count}. Their margin was not eliminated.',
        eliminations_revenue_note: 'There is nothing to eliminate on the revenue side: an intercompany invoice was never in a daily snapshot.',
        eliminations_title:        'Intercompany eliminations',
        eliminations_totals_only:  'Taken off the group total only; in these rows the two sides of an invoice are never in one row.',
        errors_hint:               'These houses could not be read. Their figures are missing.',
        errors_title:              'Unreadable houses',
        excluded_hint:             'The service left these houses out of the group total.',
        excluded_title:            'Excluded houses',
        fold_company:              'By company',
        fold_group:                'Group',
        fold_house:                'By house',
        houses_short:              'houses: {count}',
        legend_currency:           '{currency} is the report currency · foreign currencies at the monthly rate ({month})',
        legend_light:              'This statement is LIGHT: revenue less materials less labour. Energy, rent, commissions and depreciation are not in it.',
        month:                     'Month',
        nights_short:              'room nights: {nights}',
        no_data:                   'No data for this month',
        no_nights_hint:            'No room night was sold in this month.',
        no_plan_hint:              'No budget is entered for this house and month.',
        open_house:                'Open reports',
        people_without_cost:       'without cost: {count}',
        reason_missing:            'The night audit has not run for this month — the house is out of the total.',
        reason_no_rate:            'No rate for the house currency this month — file one under Exchange rates.',
        revenue_split:             'rooms {room} · food {fnb}',
        status_missing:            'No night audit',
        status_no_rate:            'No rate',
        status_ok:                 'OK',
        subtitle:                  'Revenue less materials less labour (light)',
        table_company:             'By company',
        table_group:               'Group',
        table_hint:                'Everything in the report currency. „—“ means there is no figure — not that it is nought.',
        table_house:               'By house',
        tile_labour:               'Labour',
        tile_labour_hint:          '{share} of revenue',
        tile_margin:               'Margin (light)',
        tile_margin_hint:          'Revenue less materials less labour',
        tile_margin_share:         'Margin %',
        tile_margin_share_hint:    'share of revenue',
        tile_materials:            'Materials',
        tile_materials_hint:       '{share} of revenue',
        tile_per_night:            'Revenue per room night',
        tile_per_night_hint:       'room nights: {nights}',
        tile_revenue:              'Revenue',
        tile_revenue_hint:         'houses in the total: {count}',
        title:                     'Statement',
        total_row:                 'Group ({counted} of {total} in the total)',
        unknown_labour:            'The labour cost has not been read.',
        unknown_margin:            'No margin: one of the costs has not been read.',
        unknown_materials:         'The materials consumption has not been read.',
        whole_group:               'Whole group',
    },

    materials: {
        column_consumption:   'Consumption',
        column_contract:      'Agreement',
        column_contracts:     'Agreements',
        column_house:         'House',
        column_houses:        'Houses',
        column_late:          'Late',
        column_overdue:       'Overdue',
        column_per_night:     'Per room night',
        column_spend:         'Spend',
        column_status:        'Status',
        column_supplier:      'Supplier',
        column_variance:      'Variance',
        contract_chain:       'chain agreement',
        contract_expiring:    'expires within 30 days',
        contract_mixed:       'house and chain',
        contract_none:        'no agreement',
        contract_property:    'house agreement',
        days_late:            '{days} days on average',
        errors_hint:          'These houses could not be read; none of their figures is anywhere in this answer.',
        errors_title:         'Houses that did not answer',
        excluded_hint:        'The service left these houses out of the group total and out of the supplier sums.',
        excluded_title:       'Excluded houses',
        expiring_short:       'expiring: {count}',
        invoices_short:       'papers: {count}',
        legend_currency:      '{currency} is the report currency · foreign currencies at the monthly rate ({month})',
        legend_overdue:       'overdue = a posted invoice whose due day has passed, with no credit note; this system holds no payment state',
        legend_spend:         'spend is the receipt lines of the month, not the invoices',
        legend_suppliers:     'merged on the tax number · at most 50 suppliers, by spend',
        lines_short:          'lines: {lines} of {priced}',
        max_late:             'worst {days} days',
        month:                'Month',
        nights_short:         'room nights: {nights}',
        no_data:              'Nothing for this month',
        no_suppliers:         'No deliveries this month',
        open_house:           'Open procurement',
        status_no_rate:       'no rate',
        status_ok:            'in the total',
        subtitle:             'what the group bought, month by month',
        table_houses:         'By house',
        table_houses_hint:    'The buying month by house, in the report currency.',
        table_suppliers:      'By supplier',
        table_suppliers_hint: 'One company across every house, merged on its tax number.',
        tile_consumption:      'Material consumed',
        tile_consumption_hint: 'houses in the total: {count}',
        tile_expiring:         'Agreements expiring',
        tile_expiring_hint:    'active agreements: {count}',
        tile_late:             'Late deliveries',
        tile_late_hint:        'of the deliveries that were promised a day',
        tile_overdue:          'Overdue invoices',
        tile_overdue_hint:     'papers: {count} · no payment state',
        tile_per_night:        'Cost per room night',
        tile_per_night_hint:   'room nights: {nights}',
        tile_variance:         'Price variance',
        tile_variance_hint:    'lines: {lines} of {priced} priced',
        title:                'Procurement',
        total_row:            'Group ({counted} of {total} houses)',
        unkeyed_hint:         'no tax number — merged on the name',
        variance_lines_short: 'lines: {count}',
    },

    staff: {
        column_absence:          'Absence',
        column_balance:          'Balance',
        column_cost:             'Labour cost',
        column_cost_per_night:   'Per room-night',
        column_department:       'Department',
        column_fte:              'FTE',
        column_headcount:        'People',
        column_hours_per_night:  'Hours per room-night',
        column_house:            'House',
        column_overtime:         'Overtime',
        column_status:           'Status',
        column_worked:           'Worked',
        cost_floor_short:        'cost unknown ({count} people)',
        errors_hint:             'These houses could not be read; none of their figures is anywhere in this answer.',
        errors_title:            'Unread houses',
        excluded_hint:           'The service left these houses out of the group total and out of every department sum.',
        excluded_title:          'Excluded houses',
        expected_short:          'owed: {hours}',
        legend_cost:             'the labour cost is an AVERAGE per post from the house codebook and never anybody\'s pay — payroll is elsewhere',
        legend_currency:         '{currency} is the report currency · other currencies at the monthly rate ({month})',
        legend_departments:      'folded by department name · hours and cost only from the houses that are in the group total',
        legend_two_cuts:         'people are counted by the home house (where the card is kept), hours by the house they were stamped in — a lent person counts once in each',
        month:                   'Month',
        month_open_badge:        'month not closed yet',
        month_open_short:        'open month',
        nights_short:            'room-nights: {nights}',
        no_data:                 'No data for this month',
        no_department:           'No department',
        no_departments:          'No hours by department in this month',
        no_nights:               'no room-night was sold in this month',
        open_house:              'Open personnel',
        status_no_rate:          'no rate',
        status_ok:               'in the total',
        subtitle:                'the group people indicators, by month',
        table_departments:       'By department',
        table_departments_hint:  'The same department across every house, folded by name. At most 50 rows, busiest first.',
        table_houses:            'By house',
        table_houses_hint:       'The people month by house, in the report currency.',
        tile_absence:            'Absence',
        tile_absence_hint:       'hours of absence: {hours}',
        tile_cost:               'Labour cost',
        tile_cost_floor:         'cost unknown — {count} people at posts with no hourly average',
        tile_cost_hint:          'modelled from the posts, in {currency}',
        tile_cost_per_night:     'Cost per room-night',
        tile_cost_per_night_hint: 'room-nights: {nights}',
        tile_fte:                'Full posts',
        tile_fte_hint:           'a full week is {hours} hours',
        tile_headcount:          'People',
        tile_headcount_hint:     'houses in the total: {count}',
        tile_hours_per_night:    'Hours per room-night',
        tile_hours_per_night_hint: 'room-nights: {nights}',
        tile_overtime:           'Overtime',
        tile_overtime_hint:      'summed per person, not per house · not a legal classification',
        tile_worked:             'Hours worked',
        tile_worked_hint:        'owed: {expected}',
        title:                   'People KPI',
        total_row:               'Group ({counted} of {total} houses)',
        trend_cost:              'Labour cost by month',
        trend_hint:              'the last {count} months',
        trend_worked:            'Hours worked by month',
    },

    close: {
        blocked_read_failed:  '{count} houses could not be read',
        blocked_title:        'The month cannot be closed yet',
        closed_title:         '{month} is closed — {at}',
        closed_toast:         '{month} is closed',
        column_closed_at:     'Closed',
        column_house:         'House',
        column_houses:        'Houses',
        column_month:         'Month',
        column_note:          'Note',
        column_state:         'State',
        confirm:              'Really close {month} for all {houses} houses? After this, these are the figures the group sends on.',
        errors_hint:          'While a house cannot be read, the month cannot be closed — its own month may be open too.',
        errors_title:         'Houses that could not be read',
        failed:               'The month could not be closed',
        history_line:         'Closed {closed}, reopened {reopened}:',
        history_title:        'Earlier closes of this month',
        key_ap_export:        'Accounting export',
        key_fx_rate_missing:  'Exchange rate',
        key_intercompany:     'Intercompany transfers',
        key_materials_month:  'Materials month',
        key_night_audits:     'Night audits',
        key_read_failed:      'House read',
        key_time_month:       'Time records',
        legend_click:         'Clicking a cell opens the screen in the house that closes it.',
        legend_modules:       'An empty cell means the tenant does not have that module — not that everything is in order.',
        month:                'Month',
        needs_finance:        'Closing needs group:finance or group:manage.',
        no_data:              'No houses in scope.',
        no_note:              'No note',
        no_reason:            'No reason',
        note:                 'Note',
        note_hint:            'What is worth reading a year from now: why the month was closed as it was.',
        past_empty:           'The group has not closed a month yet.',
        past_hint:            'What the group has declared finished, and when.',
        past_title:           'Closed months',
        reason:               'Reason',
        reopen:               'Reopen',
        reopen_failed:        'The month could not be reopened',
        reopen_hint:          'A closed month has already been reported on. The reason is what somebody will ask about a year from now.',
        reopen_title:         'Reopen the group month',
        reopened_title:       'Reopened {at}',
        reopened_toast:       '{month} is open again',
        state_blocked:        'Blocked',
        state_closed:         'Closed',
        state_hint:           'Whether the group month is closed, and what was written about it.',
        state_open:           'Open',
        state_reopened:       'Reopened',
        state_title:          'State of the month',
        status_blocking:      'blocking',
        status_ok:            'ok',
        status_warning:       'warning',
        submit:               'Close the month',
        subtitle:             'What is still missing before the group month is finished',
        table_hint:           'One row per house, one column per source. A row is tinted by its worst cell.',
        table_title:          'By house',
        tile_blocking:        'Blocking',
        tile_blocking_hint:   'houses stopping the close',
        tile_houses:          'Houses',
        tile_houses_hint:     'in scope for {month}',
        tile_ok:              'In order',
        tile_ok_hint:         'houses with nothing outstanding',
        tile_warnings:        'Warnings',
        tile_warnings_hint:   'houses with a warning that does not block',
        title:                'Month close',
    },

    fx: {
        column_currency:      'Currency',
        column_entered_by:    'Entered by',
        column_month:         'Month',
        column_rate:          'Rate (1 unit in {report})',
        column_source:        'Source',
        currency_confirm:     'Really change the report currency from {from} to {to}? Every consolidated figure so far is in {from}.',
        currency_saved:       'The report currency is {currency}',
        dialog_title:         'Enter a rate',
        enter:                'Enter',
        full_time_week:       'Full working week',
        full_time_week_hint:  'Hours a week that count as one full post in this group. The FTE figures on People KPI are measured against it.',
        legend_manual:        'the controller enters the rate; a published rate is only a proposal',
        legend_missing:       'a month with no rate — that house is out of the group total for it',
        mail_property:        'Sending house',
        mail_property_hint:   'Reports are mailed through this house\'s own SMTP settings.',
        mail_property_none:   'None chosen',
        missing:              'not entered',
        no_currencies:        'Every house counts in the report currency — there is nothing to convert.',
        no_suggestion:        'No proposal',
        rate:                 'Rate (1 {currency} in {report})',
        rate_hint:            'How much {report} one unit of {currency} is worth in this month.',
        report_currency:      'Report currency',
        report_currency_hint: 'The currency every consolidated figure of the group is in.',
        saved:                'The {currency} rate for {month} has been saved',
        settings_hint:        'What the group counts in, and the clock its day ends on.',
        settings_title:       'Group settings',
        source:               'Source',
        source_hint:          'Where the rate came from — "NBS, 1 Sep". A rate with no source is one nobody can defend in six months.',
        subtitle:             'the monthly rates for reporting',
        suggestion:           'Proposal {source} {rate} of {date}',
        suggestion_hint:      'The proposal is not saved until you confirm it.',
        table_hint:           'Three months back and three ahead. Every rate is in {report}.',
        table_title:          'Rates by currency and month',
        timezone:             'Time zone',
        title:                'Exchange rates',
    },

    channels: {
        as_of:                  'refreshed {time}',
        column_connection:      'Connection',
        column_health:          'State',
        column_house:           'House',
        column_last_error:      'Last error',
        column_last_push:       'Last push',
        column_no_room:         'No room',
        column_queue:           'Waiting / failed',
        errors_hint:            'These houses could not be read, so they are in none of the tiles above.',
        errors_title:           'Houses that did not answer',
        full_sync_owed:         'owes a full sync',
        health_error:           'error',
        health_none:            'no channels',
        health_ok:              'ok',
        health_warning:         'warning',
        legend_none:            '„no channels“ is not a fault: the house sells its own rooms',
        legend_queue:           'the left figure is dates waiting, the right one dates the aggregator refused',
        never_pushed:           'never',
        no_connections:         'no connection',
        no_rows:                'No houses in this scope',
        open:                   'Open channels',
        push_delta:             'changes',
        push_full:              'full sync',
        state_connected:        'connected',
        state_draft:            'draft',
        state_error:            'error',
        state_suspended:        'suspended',
        subtitle:               'is the group still selling',
        table_hint:             'One row per house. Repaired in the house\'s reception, not here.',
        table_title:            'By house',
        tile_connections:       'Connections',
        tile_connections_hint:  'all connections in scope',
        tile_errors:            'Errors',
        tile_errors_hint:       'refused dates: {count}',
        tile_houses:            'Houses',
        tile_houses_hint:       'connections: {count}',
        tile_no_room:           'Bookings with no room',
        tile_no_room_hint:      'arrived from the channels, waiting at the desk',
        tile_warnings:          'Warnings',
        tile_warnings_hint:     'houses where something is stalling',
        title:                  'Channels',
    },

    alerts: {
        chip_all:         'All',
        next:             'Open in reception',
        none:             'Nothing waiting. No open alerts in this scope.',
        panel_controller: 'Controller',
        panel_count:      'rows: {count}',
        panel_director:   'Director',
        panel_empty:      'Nothing waiting',
        panel_sales:      'Sales',
        pill_critical:    'critical: {count}',
        pill_refreshed:   'refreshed {time}',
        pill_warning:     'warnings: {count}',
        subtitle:         'what is waiting for me',
        title:            'Alerts',
    },

    operations: {
        badge_redacted:      '{count} hidden',
        badge_redacted_hint: 'Houses of this operation outside your scope. Their outcome is not shown.',
        badge_running:       'running',
        claimed:             'The operation has started; no house has answered yet.',
        kind_rebuild:        'Snapshot rebuild',
        no_data:             'No group operations recorded',
        no_targets:          'This operation reached no house.',
        requested:           '{who} · {when}',
        retry:               'Retry the failures',
        retry_confirm:       'Run „{kind}“ again for the houses that did not take it (houses: {count})?',
        retry_failed:        'The retry could not be started.',
        retry_hint:          'The same press again, only for the houses that did not take it.',
        retry_started:       'The retry has started.',
        show_targets:        'By house (houses: {count})',
        status_failed:       'failed',
        status_ok:           'ok',
        status_running:      'running',
        status_skipped:      'skipped',
        status_unknown:      'no answer',
        subtitle:            'what the group ran, and how it went',
        summary_failed:      '{count} failed',
        summary_none:        'no houses',
        summary_ok:          '{count} ok',
        summary_running:     'running',
        summary_skipped:     '{count} skipped',
        title:               'Operations log',
        unknown_user:        'unknown user',
    },

    milo: {
        confirm_delete:      'Delete this conversation?',
        conversations:       'Conversations',
        disclaimer:          'Milo answers from the group\'s own data and changes nothing. Check a figure on the screen it came from before you act on it.',
        example_attention:   'Which houses need attention?',
        example_occupancy:   'How full was the group yesterday?',
        example_pickup:      'How much is on the books for November?',
        failed:              'Milo could not answer.',
        failed_lost:         'The answer was lost. Ask again.',
        failed_timeout:      'The answer is taking too long. Try again.',
        greeting:            'I am Milo, the head office assistant.',
        intro:               'Ask me about occupancy, revenue and reservations of the houses in the current scope. I only read.',
        new_conversation:    'New conversation',
        no_conversations:    'No conversations yet',
        placeholder:         'Ask Milo …',
        retry:               'Send again',
        scope_hint:          'Milo answers within this scope.',
        send:                'Send',
        still_working:       'A question across several houses can take up to a minute.',
        subtitle:            'questions about the group',
        thinking:            'Reading the data …',
        title:               'Milo',
        tools:               'Sources ({count})',
        untitled:            'Untitled',
    },

    reports: {
        active_hint:          'A report that is off stays written down and does not run.',
        add_section:          'Add section',
        added:                'Report “{title}” was added',
        attention:            'needing attention: {count}',
        back:                 'Back to reports',
        back_to_runs:         'Back to runs',
        confirm_delete:       'Delete the report “{title}”?',
        date_today:           'Today',
        date_yesterday:       'Yesterday',
        deleted:              'Report “{title}” was deleted',
        delivered_at:         'sent {when}',
        delivery_email:       'Send by e-mail',
        dialog_hint:          'The sections, the hour and the scope the report answers for.',
        edit_report:          'Edit report',
        field_active:         'On',
        field_date:           'Day',
        field_delivery:       'Delivery',
        field_delivery_hint:  'Only a link to the run is mailed; the figures stay in the console.',
        field_hour:           'Hour',
        field_hour_hint:      'The hour in the group\'s own time zone.',
        field_minute:         'Minute',
        field_months:         'Horizon',
        field_scope:          'Scope',
        field_scope_hint:     'Which houses the report answers for.',
        field_sections:       'Sections',
        field_sections_hint:  'The order of the sections is the order they are read in.',
        field_title:          'Title',
        field_title_hint:     'What the e-mail subject and the top of the run say.',
        field_tool:           'What the section reads',
        field_weekdays:       'Days',
        field_weekdays_hint:  'The weekdays the report runs on.',
        last_run:             'last run {when}',
        move_down:            'Move down',
        move_up:              'Move up',
        narrative:            'Summary',
        never_run:            'Has not run yet',
        new_report:           'New report',
        no_runs:              'This report has not run yet',
        none:                 'No reports yet',
        none_hint:            'A report is a list of sections that builds itself from the houses in scope at an agreed hour.',
        off:                  'Off',
        on:                   'On',
        open_run:             'Open run',
        remove_section:       'Remove section',
        run:                  'Run',
        run_failed:           'The run could not be started',
        run_now:              'Run now',
        runs:                 'Runs',
        runs_subtitle:        'when the report ran and how it ended',
        saved:                'Report “{title}” was saved',
        schedule_daily:       'every day at {time}',
        schedule_days:        '{days} at {time}',
        schedule_never:       'no day — the report does not run',
        schedule_workdays:    'every workday at {time}',
        scope_all:            'My whole scope',
        scope_all_hint:       'Including a house opened tomorrow.',
        scope_current:        'The current selection ({scope})',
        scope_current_hint:   'A frozen list of houses — {count} of them.',
        scope_narrowed:       'houses: {count}',
        section_empty:        'There is nothing for this section.',
        section_failed:       'This section could not be built.',
        section_no_permission: 'You may not see this section.',
        section_unknown:      'This console cannot draw this section.',
        status_claimed:       'Running',
        status_delivered:     'Sent',
        status_failed:        'Failed',
        status_missed:        'Missed',
        status_not_delivered: 'Not sent',
        status_rendered:      'Built',
        subtitle:             'the group\'s morning report',
        switched_off:         'Report “{title}” is off',
        switched_on:          'Report “{title}” is on',
        tile_attention:       'Needing attention',
        tile_attention_hint:  'across every section',
        tile_due:             'Due at',
        tile_due_hint:        'in the group\'s time zone',
        tile_rendered:        'Built',
        tile_rendered_hint:   'when the run was drawn',
        tile_sections:        'Sections',
        tile_sections_hint:   'with data: {count}',
        title:                'Reports',
        tool_kpi_daily:       'Daily flash',
        tool_kpi_daily_hint:  'Occupancy, ADR, RevPAR and room revenue per house.',
        tool_live_today:      'The houses today',
        tool_live_today_hint: 'Arrivals, departures and unassigned rooms as they stood at the run.',
        tool_overview:        'What is waiting',
        tool_overview_hint:   'Alerts in three panels — director, controller, sales.',
        tool_pickup:          'Pickup',
        tool_pickup_hint:     'What is on the books for the months ahead.',
        tool_tree:            'The group structure',
        tool_tree_hint:       'Units, houses and the ones with no company.',
    },

    live: {
        column_arrivals:    'Arrivals',
        column_departures:  'Departures',
        column_house:       'House',
        column_in_house:    'In house',
        column_night_audit: 'Last night audit',
        column_unassigned:  'Unassigned rooms',
        never_closed:       'never',
    },

    tree: {
        houses:     'houses: {count}',
        no_company: 'no company: {count}',
        no_unit:    'No unit',
        units:      'units: {count}',
        unassigned: 'no company',
    },

    rebuild: {
        action:         'Rebuild snapshots',
        done:           'Days written: {written}',
        done_missing:   'Without data: {missing}. The house has no night audit for those days.',
        failed:         'The rebuild could not be run',
        from:           'From',
        from_hint:      'The first day to read again.',
        scope_group:    'The rebuild covers every house you may see.',
        scope_selected: 'The rebuild covers the picked houses (houses: {count}).',
        submit:         'Rebuild',
        subtitle:       'Reads the days out of the houses again and refreshes the consolidated figures.',
        title:          'Rebuild snapshots',
        to:             'To',
        to_hint:        'The last day to read again. Inclusive.',
    },

    entity: {
        accounting_none:              'None',
        accounting_organisation:      'Organisation id',
        accounting_organisation_hint: 'What the accounting system calls this company.',
        accounting_system:            'Accounting system',
        accounting_system_hint:       'Where this company\'s exports go. None means it is not exported yet.',
        active:                       'Active',
        active_hint:                  'An inactive company can no longer be picked when a house is transferred.',
        active_no:                    'No',
        active_yes:                   'Yes',
        add:                          'Add a company',
        address_country:              'Address country',
        address_country_hint:         'Usually the company\'s own country, but not necessarily.',
        added:                        'The company has been added',
        bic:                          'BIC',
        city:                         'City',
        country:                      'Country',
        country_currency:             'Country / currency',
        currency:                     'Currency',
        currency_hint:                'The currency this company keeps its books in (EUR, HRK …).',
        delete_confirm:               'Delete the company “{name}”?',
        deleted:                      'The company has been deleted',
        dialog_hint:                  'The company is the master source for the name, the tax number and the IBAN. An invoice still prints the house\'s own identity.',
        drift:                        'Divergences',
        drift_entity_value:           'At the company',
        drift_hint:                   'Where a house\'s identity differs from its company\'s record. Which of them is right is a question for a person: correct the house in the reception portal, the company here.',
        drift_none:                   'No divergences',
        drift_property_value:         'At the house',
        drift_title:                  'Divergences from the houses',
        edit:                         'Edit the company',
        field_address:                'Address',
        field_bic:                    'BIC',
        field_country:                'Country',
        field_currency:               'Currency',
        field_iban:                   'IBAN',
        field_name:                   'Name',
        field_registration_number:    'Registration number',
        field_short_name:             'Short name',
        field_tax_number:             'Tax number',
        field_vat_id:                 'VAT id',
        group_accounting:             'Accounting',
        group_bank:                   'Bank',
        group_basic:                  'Basics',
        group_tax:                    'Tax',
        houses:                       'Houses',
        iban:                         'IBAN',
        name:                         'Name',
        no_data:                      'No companies entered yet',
        payroll_code:                 'Payroll code',
        payroll_code_hint:            'What the payroll run calls this company. Empty until payroll is exported.',
        postal_code:                  'Postal code',
        registration_number:          'Registration number',
        saved:                        'The company has been saved',
        search:                       'Search for a company',
        short_name:                   'Short name',
        short_name_hint:              'The name shown in pickers when the full one is too long.',
        street:                       'Street and number',
        subtitle:                     'who owns the houses',
        tax_number:                   'Tax number',
        tax_number_hint:              'Together with the country, this identifies the company.',
        tax_vat:                      'Tax number / VAT id',
        title:                        'Companies',
        vat_id:                       'VAT id',
        vat_id_hint:                  'With the country prefix, as it is on an invoice (SI12345678).',
    },

    structure: {
        add_child:               'Add below',
        add_unit:                'Add a unit',
        assign:                  'Assign a company',
        delete_confirm:          'Delete the unit “{name}”?',
        edit_unit:               'Edit the unit',
        houses_count:            'houses: {count}',
        kind_brand:              'Brand',
        kind_region:             'Region',
        move:                    'Move to a unit',
        move_hint:               'Where this house reports. It changes nothing about how the house operates.',
        move_title:              'Move to a unit',
        moved:                   'The house has been moved',
        no_company:              'no company',
        pick_unit:               'Pick a unit',
        rename:                  'Rename',
        subtitle:                'who reports to whom',
        title:                   'Structure',
        unassigned_houses:       'Unplaced houses',
        unassigned_houses_hint:  'in no unit at all',
        unit:                    'Unit',
        unit_added:              'The unit has been added',
        unit_deleted:            'The unit has been deleted',
        unit_kind:               'Kind',
        unit_kind_hint:          'A region is geography, a brand is how a house is sold. A house reports through one or the other, never both.',
        unit_name:               'Unit name',
        unit_parent:             'Parent unit',
        unit_parent_hint:        'The tree is at most two levels deep: group → region or brand → house.',
        unit_saved:              'The unit has been saved',
        unit_sort:               'Order',
        unit_sort_hint:          'A smaller number sits higher in the list.',
    },

    transfer: {
        company:              'New company',
        company_hint:         'The owner of the house from the chosen date onwards.',
        current_company:      'Current company',
        done:                 'The house has been transferred',
        failed:               'The transfer could not be carried out',
        history:              'What happens to the history',
        history_follows:      'The whole history follows the house',
        history_follows_hint: 'Every past period reads as the new company\'s. For a reorganisation inside one holding.',
        history_stays:        'Past periods stay with the previous company',
        history_stays_hint:   'What was booked under the old company stays its own; the new one counts from the date onwards. For a sale.',
        no_company:           'not assigned',
        pick_company:         'Pick a company',
        new_company:          'New company',
        submit:               'Transfer',
        title:                'Assign a company',
        valid_from:           'Valid from',
        valid_from_hint:      'The first day the new company counts.',
    },

    accounting: {
        add_row:                 'Add row',
        column_already_sent:     'Already sent',
        column_category:         'Category',
        column_cogs:             'Cost of goods sold',
        column_consumption:      'Consumption',
        column_cost_centre:      'Cost centre',
        column_drafts:           'Drafts',
        column_house:            'Property',
        column_inventory:        'Inventory',
        column_invoices:         'Invoices',
        column_items:            'Articles',
        column_last_export:      'Last export',
        column_lines:            'Lines',
        column_note:             'Note',
        column_organisation:     'Organisation',
        column_period:           'Period',
        column_sent_at:          'Sent',
        column_state:            'State',
        column_unallocated:      'No analytic',
        company:                 'Company',
        coverage:                'Coverage by property',
        coverage_hint:           'Which rule answers for each category in each property. What nothing answers posts to a blank account.',
        from:                    'From',
        history:                 'Hand-off history',
        history_hint:            'What this company’s properties have already handed over, newest first.',
        houses:                  'Properties of the company',
        houses_hint:             'Each property sends with its own credentials. The head office neither sees nor changes them.',
        legend_blocked:          'Grey row: the press does not reach this property.',
        legend_company:          '„company“ badge: the company map answered.',
        legend_drafts:           'Drafts are not in the books yet — the book-keeper has to add an expense.',
        legend_house:            '„property“ badge: the property has its own row and the company cannot override it.',
        legend_none:             '„missing“ badge: nothing answers — this category posts to a blank account.',
        legend_ready:            'Green badge: credentials entered and the right organisation.',
        map:                     'Company account map',
        map_failed:              'The map could not be saved',
        map_footer:              'The company map answers only where a property has no row of its own. A row removed from this table is deleted on save.',
        map_hint:                'It fills the properties’ gaps. Where a property has its own mapping, this row does not apply.',
        map_saved:               'The map is saved',
        no_coverage:             'No properties with categories',
        no_history:              'This company has handed over nothing yet',
        no_houses:               'This company has no properties in scope',
        no_map:                  'The company has no mappings',
        not_sent:                'not sent',
        open_house:              'Open the property’s accounting',
        organisation_expected:   'the company posts into {organisation}',
        organisation_unset:      'not set',
        pick_company:            'Pick a company',
        pick_company_hint:       'Pick the company whose purchases you want to hand to the book-keeper.',
        refusals:                'To finish',
        refusals_hint:           'What the last hand-off left open at the book-keeper.',
        send:                    'Send to accounting',
        send_done:               'Sent: {sent} of {houses} properties',
        send_failed:             'The hand-off could not be made',
        send_houses:             'The press reaches {ready} of {houses} properties.',
        send_skipped:            'Properties skipped: {count}',
        send_subtitle:           'Each property sends with its own credentials, one after another.',
        send_title:              'Send to accounting',
        source_company:          'company',
        source_department:       'department',
        source_house:            'property',
        source_item:             'article',
        source_none:             'missing',
        state_mismatch:          'Different organisation',
        state_not_ready:         'No credentials',
        state_ready:             'Ready',
        subtitle:                'the company’s purchases to its book-keeper',
        system_file:             'Accounting: file. Sending to Minimax is not available.',
        system_minimax:          'Minimax, organisation {organisation}',
        system_none:             'No accounting system chosen. Edit the company on the Companies screen.',
        tab_export:              'Export',
        tab_map:                 'Account map',
        target_ok:               'sent',
        tile_attention:          'To review',
        tile_attention_hint:     'properties the press does not reach',
        tile_houses:             'Properties',
        tile_houses_hint:        'ready: {ready}',
        tile_invoices:           'Invoices in the period',
        tile_invoices_hint:      'posted supplier invoices',
        tile_lines:              'Lines',
        tile_lines_hint:         'items on those invoices',
        title:                   'Accounting',
        to:                      'To',
        unreadable:              'Properties that could not be read',
    },

    contract: {
        activate:                'Activate',
        activated:              'Contract “{name}” is now in force',
        allotment:               'Allotment',
        allotment_hint:          'How many rooms a night the firm may take in each house, and how many days before arrival what it has not taken goes back on sale. Recorded, not enforced — no booking is stopped by it.',
        allotment_release:       'days release',
        allotment_rooms:         'rooms a night',
        any_company:             'All firms',
        any_status:              'All states',
        code_houses:             '{count} houses',
        column_actions:          'Actions',
        column_active_contracts: 'Live contracts',
        column_code:             'Rate plan code',
        column_company:          'Firm',
        column_houses:           'Houses',
        column_name:             'Name',
        column_nights:           'Room nights',
        column_revenue:          'Revenue',
        column_status:           'State',
        column_validity:         'Validity',
        company:                 'Firm',
        company_hint:            'A contract is with one firm, even when it covers nine houses.',
        company_placeholder:     'Search for a firm …',
        company_refused:         'The register of firms could not be read',
        company_required:        'Choose a firm',
        contact_email:           'Contact e-mail',
        contact_name:            'Contact',
        contact_phone:           'Contact telephone',
        created:                'Draft contract “{name}” saved',
        credit_limit:            'Credit limit',
        credit_limit_hint:       'Zero means no cap.',
        delete_confirm:         'Delete the draft contract “{name}”?',
        deleted:                'Draft “{name}” deleted',
        dialog_edit:             'Edit contract',
        dialog_hint:             'A contract is born a draft. It is activated with its own button, because that is when every house is checked for a rate plan with this code.',
        dialog_new:              'New contract',
        end:                     'End',
        end_reason:              'Reason',
        end_reason_hint:         'Why it ends. It is kept — a year from now it is the first thing anybody reads.',
        end_title:               'Ending a contract',
        ended:                  'Contract “{name}” has ended',
        errors_hint:             'These houses did not answer. Their figures are not in the totals.',
        errors_title:            'Houses that could not be read',
        excluded_hint:           'These houses lost their money because no rate is filed for their currency. Their room nights stand.',
        excluded_title:          'Excluded houses',
        expand:                  'Show houses',
        filter_company:          'Firm',
        filter_status:           'State',
        from:                    'From',
        houses:                  'Houses',
        houses_all:              'Every house of the group',
        houses_count:            '{count} houses',
        houses_hint:             'Empty means every house of the group — including the ones that open later.',
        legend_capped:           'The list is cut at two hundred firms.',
        legend_code:             'A tinted row: some of the contract’s houses carry no rate plan with this code.',
        legend_currency:         'Amounts are in {currency}, converted at the rate of the month the money belongs to.',
        legend_ended:            'Ended contracts are kept — they explain the prices on invoices already issued.',
        legend_nights:           'Room nights are counted where the stay ARRIVES in the period.',
        missing_code:            'rate plan missing in {count} houses',
        name:                    'Contract name',
        new:                     'New contract',
        nights_short:            '{count} nights',
        no_contracts:            'No contracts',
        no_production:           'No corporate production in this period',
        notes:                   'Notes',
        open_end:                'no end',
        open_hint:               'Empty means an open end.',
        open_start:              'no start',
        payment_terms:           'Payment terms (days)',
        payment_terms_hint:      'Zero means the firm’s own default.',
        production_hint:         'What the firms actually brought, house by house, in the report currency.',
        production_title:        'Production by firm',
        rate_plan_code:          'Rate plan code',
        rate_plan_code_hint:     'A contract names a rate plan by CODE and not by id: one code means one price list in every house. Below are the codes the houses in scope actually carry.',
        saved:                  'Contract “{name}” saved',
        status_active:           'Live',
        status_draft:            'Draft',
        status_ended:            'Ended',
        status_no_rate:          'no rate',
        subtitle:                'the group’s corporate agreements',
        tab_contracts:           'Contracts',
        tab_production:          'Production',
        table_hint:              'What the group agreed, with whom, on which price list, and whether every house carries it.',
        table_title:             'Group contracts',
        terms:                   'Agreed terms',
        terms_days:              '{days} days’ terms',
        terms_hint:              'The benefits in the words they were agreed in — breakfast, late check-out, a discount at the bar.',
        title:                   'Contracts',
        to:                      'To',
        total_row:               'Total ({count} firms)',
        unknown_company:         'Unknown firm',
        valid_from:              'Valid from',
        valid_to:                'Valid to',
    },

    intercompany: {
        attention_badge:      'Needs a look',
        book_hint:            'By pair of companies: what moved, what has been invoiced, and what is on no invoice at all.',
        book_title:           'The month',
        buyer:                'Buyer',
        buyer_all:            'All buyers',
        buyer_filter:         'Buyer',
        buyer_hint:           'The company that pays.',
        cancel_failed:        'The invoice could not be cancelled',
        cancel_hint:          'An issued invoice is never modified. Cancelling leaves it on record but it no longer stands.',
        cancel_invoice:       'Cancel invoice',
        cancel_reason:        'Reason',
        cancel_reason_hint:   'Why the invoice was cancelled. The reason stays with it.',
        cancel_refused:       'The cancellation was refused',
        cancel_title:         'Cancel invoice',
        cancelled_toast:      'Invoice {number} has been cancelled',
        column_buyer:         'Buyer',
        column_dates:         'Date',
        column_drafts:        'Drafts',
        column_gross:         'Gross',
        column_issued:        'Issued',
        column_item:          'Item',
        column_markup:        'Markup',
        column_mirror:        'Mirror',
        column_net:           'Net',
        column_note:          'Note',
        column_number:        'Number',
        column_parties:       'Seller → buyer',
        column_quantity:      'Quantity',
        column_seller:        'Seller',
        column_status:        'Status',
        column_tax:           'VAT',
        column_tax_rate:      'Rate',
        column_terms:         'Terms',
        column_transfers:     'Transfers',
        column_unit_cost:     'Unit cost',
        column_unit_price:    'Unit price',
        column_unmatched:     'Unmatched',
        column_vat_mode:      'VAT treatment',
        days:                 '{count} days',
        document_hash:        'Document hash: {hash}',
        draft_number:         'draft',
        due_short:            'due {date}',
        iban:                 'IBAN',
        invoices_hint:        'The intercompany invoices of the chosen month. Click a row to open one.',
        invoices_title:       'Invoices',
        issue:                'Issue',
        issue_failed:         'The invoice could not be issued',
        issue_note:           'Note',
        issue_note_hint:      'Optional. It stays in the record of the issue.',
        issue_title:          'Issue invoice',
        issued_on:            'Issue date',
        issued_on_hint:       'The day that goes on the document. The number is reserved at issue.',
        issued_toast:         'Invoice {number} was issued on {date}',
        legend_attention:     'Amber row: the service wrote a note about this invoice.',
        legend_currency:      'The amount is in the pair’s own currency, not the report currency.',
        legend_direction:     'A pair is ordered: seller → buyer.',
        legend_draft:         'A draft has no number — one is reserved only at issue.',
        legend_mirror:        'The mirror is the buyer’s incoming invoice; it exists only after issue.',
        legend_unmatched:     'Amber row: stock that moved and is on no invoice.',
        markup:               'Markup (%)',
        markup_hint:          'Per cent on top of cost. 0 % means selling at cost.',
        markup_range:         'The markup is between 0 and 100 %.',
        merge:                'Merge selected',
        merge_drafts_only:    'Only drafts can be merged.',
        merge_failed:         'The drafts could not be merged',
        merge_need_two:       'Select at least two drafts.',
        merge_one_pair:       'Every selected draft has to be of one pair and in one currency.',
        merged:               'Drafts merged: {count}',
        mirror_badge:         'Mirror: {state}',
        mirror_draft:         'Draft',
        mirror_matched:       'Matched',
        mirror_posted:        'Posted',
        month:                'Month',
        no_invoices:          'No invoices this month',
        no_lines:             'This invoice has no lines',
        no_pairs_month:       'Nothing moved between companies this month',
        no_rules:             'No pairs agreed yet',
        no_rules_hint:        'Without a pair, a transfer between two companies is invoiced at cost.',
        note:                 'Note',
        note_hint:            'Optional. Who the agreement covers, from when, who made it.',
        open_pair:            'Open this pair’s invoices',
        operation_id:         'Operation id: {id}',
        pair_add:             'Add pair',
        pair_delete_confirm:  'Delete the agreement {seller} → {buyer}? Issued invoices stay; new drafts will carry no markup.',
        pair_deleted:         'The pair {seller} → {buyer} has been deleted',
        pair_direction:       'A pair is ordered: seller → buyer. The other direction is a row of its own with its own markup.',
        pair_edit:            'Edit pair',
        pair_locked:          'The companies cannot be swapped while editing — they ARE the pair. Add a new pair for the other direction.',
        pair_same_company:    'The seller and the buyer have to be two different companies.',
        pair_saved:           'The pair {seller} → {buyer} has been saved',
        pairs_hint:           'What two companies agreed: the markup and the payment terms. New invoices are priced by it.',
        pairs_title:          'Company pairs',
        payment_terms:        'Payment terms (days)',
        payment_terms_hint:   'How many days after issue the invoice falls due. At most 120.',
        pdf:                  'PDF',
        pick_company:         'Pick a company',
        recapitulative:       'Recapitulative statement',
        recapitulative_hint:  'This invoice goes into the recapitulative statement.',
        recapitulative_short: 'recapitulative',
        reverse_charge_clause: 'Clause',
        select_row:           'Select invoice',
        seller:               'Seller',
        seller_all:           'All sellers',
        seller_filter:        'Seller',
        seller_hint:          'The company that invoices.',
        status_all:           'All statuses',
        status_cancelled:     'Cancelled',
        status_draft:         'Draft',
        status_filter:        'Status',
        status_issued:        'Issued',
        subtitle:             'invoices between companies from stock transfers',
        tab_book:             'The month',
        tab_invoices:         'Invoices',
        tab_pairs:            'Pairs',
        tax_number:           'Tax number',
        terms_range:          'Payment terms are between 0 and 120 days.',
        title:                'Intercompany',
        total_row:            'Total ({count} lines)',
        transfers_short:      'transfers: {count}',
        vat_domestic:         'Domestic VAT',
        vat_id:               'VAT id',
        vat_none:             'No VAT',
        vat_reverse_charge:   'Reverse charge',
    },

    rate: {
        action_conflict:                  'Conflict',
        action_create:                    'New plan',
        action_update:                    'Update',
        active_no:                        'Inactive',
        active_yes:                       'Active',
        add:                              'New template',
        add_category:                     'New category',
        add_price:                        'Add a price',
        add_rung:                         'Add a step',
        add_title:                        'New rate template',
        added:                            'Template {code} was added',
        all_templates:                    'All templates',
        board_all_inclusive:              'All inclusive',
        board_breakfast:                  'Breakfast',
        board_full_board:                 'Full board',
        board_half_board:                 'Half board',
        board_none:                       'Room only',
        bulk_done:                        'Written to {written} of {houses} properties',
        bulk_failed:                      'The restrictions could not be written',
        bulk_scope:                       'The press reaches {scope} — {count} properties.',
        categories:                       'Room categories',
        categories_hint:                  'The vocabulary of the group. A template prices a category; a property maps its room types onto it.',
        category_active_hint:             'An inactive category is not offered to a new template; the mappings that exist stay.',
        category_add:                     'New room category',
        category_added:                   'Category {code} was added',
        category_code_hint:               'The code a template prices — STD, SUP, SUITE.',
        category_delete_confirm:          'Delete the category "{name}"?',
        category_deleted:                 'Category {code} was deleted',
        category_dialog_hint:             'A word of the group, not a room of a property.',
        category_edit:                    'Edit the room category',
        category_in_use:                  'Category {code} is still in use — properties map room types onto it. Deactivate it instead of deleting it.',
        category_saved:                   'Category {code} was saved',
        category_sort_hint:               'The place in a list. A smaller number comes first.',
        column_action:                    'Action',
        column_active:                    'Active',
        column_board:                     'Board',
        column_category:                  'Category',
        column_code:                      'Code',
        column_covered:                   'Covered categories',
        column_currency:                  'Currency',
        column_days_before:               'Days before arrival',
        column_deviations:                'Price deviations',
        column_discount:                  'Discount (%)',
        column_house:                     'Property',
        column_house_version:             'Version at the property',
        column_mapped:                    'Mapped',
        column_name:                      'Name',
        column_notes:                     'Notes',
        column_overrides:                 'Overrides',
        column_plan:                      'Rate plan',
        column_price_extra:               'Extra adult',
        column_price_standard:            'Standard occupancy',
        column_room_types:                'Room types',
        column_room_types_list:           'Room types',
        column_sort:                      'Order',
        column_template:                  'Template',
        column_unmapped:                  'Unmapped',
        column_version:                   'Version',
        coverage:                         'Coverage by property',
        coverage_hint:                    'Which room type of which property carries a category, and which carries none. A push cannot price a room type with none.',
        covered_of:                       '{covered} of {total} covered',
        currency_fixed:                   'The currency of the template',
        currency_house:                   'The currency of the property',
        delete_confirm:                   'Delete the template "{name}"?',
        deleted:                          'Template {code} was deleted',
        deviation_days:                   '{differing} of {compared} days',
        dialog_hint:                      'A decision of the group. Nothing reaches a property until a push.',
        early_booking:                    'Discount steps',
        early_booking_hint:               'The steps have to fall in days: 90 days ahead buys more than 30 days ahead.',
        edit_title:                       'Edit the rate template',
        field_active:                     'Active',
        field_active_hint:                'An inactive template cannot be pushed.',
        field_apply_prices:               'Write prices',
        field_apply_prices_hint:          'The prices of the template are written over the window. Without it they stay as they are.',
        field_apply_restrictions:         'Write restrictions',
        field_apply_restrictions_hint:    'The default restrictions of the template are written over the window.',
        field_board_type:                 'Board',
        field_cancellation_name:          'Name of the cancellation policy',
        field_cancellation_name_hint:     'What a guest reads when booking.',
        field_cancellation_policy:        'Cancellation policy',
        field_categories:                 'Categories',
        field_categories_hint:            'With nothing picked it holds for every category of the plan.',
        field_code:                       'Code',
        field_code_hint:                  'The short code the properties recognise this plan by.',
        field_currency:                   'Currency',
        field_currency_hint:              'It holds only where the template names the currency itself.',
        field_currency_mode:              'Pricing currency',
        field_currency_mode_hint:         'The currency of the property means each property sells in its own.',
        field_days_before_arrival:        'Days before arrival',
        field_days_before_arrival_hint:   'Up to when a cancellation is still free.',
        field_deadline_hour:              'Hour',
        field_deadline_minute:            'Minute',
        field_early_booking:              'Early booking',
        field_fields:                     'What gets written',
        field_fields_hint:                'Exactly what you pick is written. Everything else on those days is left alone.',
        field_free_cancellation:          'Free cancellation',
        field_free_cancellation_hint:     'Without it a booking is non-refundable from the moment it is confirmed.',
        field_from:                       'From',
        field_max_stay:                   'Maximum nights',
        field_min_advance_booking:        'Minimum days in advance',
        field_min_stay:                   'Minimum nights',
        field_name:                       'Name',
        field_offset:                     'Offset',
        field_offset_type:                'Kind of offset',
        field_offset_value:               'Offset',
        field_offset_value_amount_hint:   'Typed in whole currency. It crosses the wire in cents.',
        field_offset_value_percent_hint:  'Typed as a per cent. It crosses the wire in basis points.',
        field_parent_code:                'Code of the parent template',
        field_parent_code_hint:           'A derived template takes its price from this one and moves it by the offset.',
        field_penalty_percent:            'Penalty per cent',
        field_penalty_percent_hint:       'Typed as a per cent. It crosses the wire in basis points.',
        field_penalty_type:               'Cancellation penalty',
        field_rate_plan_code:             'Rate plan code',
        field_rate_plan_code_hint:        'It writes over the plan spelled this way in each property.',
        field_refundable:                 'Refundable',
        field_refundable_hint:            'A non-refundable plan is paid on confirmation and not returned.',
        field_room_categories:            'Room categories',
        field_room_categories_hint:       'Which categories this template prices. What a property has none of is listed in the preview.',
        field_template:                   'Template',
        field_template_hint:              'It writes over every plan the properties carry from this template.',
        field_to:                         'To',
        field_type:                       'Kind',
        field_weekdays:                   'Weekdays',
        field_weekdays_hint:              'With nothing picked it holds for every day of the window.',
        field_window_hint:                'The window it is written over. A year ahead by default.',
        fields_hint:                      'Exactly what you pick is written.',
        free_no:                          'No free cancellation',
        free_yes:                         'Free cancellation',
        group_basic:                      'Basics',
        group_cancellation:               'Cancellation',
        group_categories:                 'Categories',
        group_early_booking:              'Early booking',
        group_price:                      'Price',
        group_restrictions:               'Restrictions',
        ladder_decreasing:                'The steps have to fall by days before arrival.',
        legend_conflict:                  'Grey row: the property carries a plan that is not from this template.',
        legend_overridden:                'Blue chip: a field the property changed itself.',
        legend_overrides:                 'Blue chip: the push leaves this alone.',
        legend_stale:                     'Grey row: the plan carries an older version of the template.',
        legend_uncovered:                 'Orange chip: a category this property has none of.',
        legend_unmapped:                  'Orange chip: a room type with no category — a push cannot price it.',
        no_categories:                    'The group has no room categories yet',
        no_coverage:                      'No property in this scope has room types',
        no_deviation:                     'no deviation',
        no_parity:                        'No property in this scope carries a plan from a template',
        no_preview_houses:                'There are no properties in this scope',
        no_prices:                        'The template has no prices yet',
        no_template:                      'No template',
        no_templates:                     'The group has no rate templates yet',
        non_refundable:                   'Non-refundable',
        offset_amount:                    'Amount',
        offset_amount_per_person:         'Amount per person',
        offset_none:                      'No offset',
        offset_percentage:                'Percentage',
        one_target_required:              'Pick a template or type a rate plan code — exactly one of the two.',
        open_rates:                       'Open the rates of the property',
        parent_of:                        'derived from {code}',
        parent_required:                  'A derived template needs a parent code.',
        parity:                           'Rate parity',
        parity_filter:                    'Template',
        parity_hint:                      'Where the properties have gone from what they were pushed.',
        parity_table_hint:                'One row per plan per property. A deviation is not a fault — it is a question for the property.',
        penalty_first_night:              'The first night',
        penalty_full_stay:                'The whole stay',
        penalty_none:                     'No penalty',
        penalty_percentage:               'A per cent of the stay',
        pick_categories:                  'Pick categories',
        preview_push:                     'Preview the push',
        preview_scope:                    'Scope: {scope}',
        preview_subtitle:                 '{code}, version {version}',
        preview_title:                    'Preview of the push',
        prices:                           'Prices by category',
        prices_hint:                      'Typed in whole currency. It crosses the wire in cents.',
        push:                             'Push',
        push_done:                        'Written to {written} of {houses} properties',
        push_failed:                      'The push could not be carried out',
        push_scope:                       'The press reaches {scope} — {count} properties.',
        push_subtitle:                    'The template is written into every property in scope.',
        push_template:                    '{code} — {name}, version {version}',
        push_title:                       'Push the template to the properties',
        refundable_no:                    'Non-refundable',
        refundable_yes:                   'Refundable',
        remove_rung:                      'Remove the step',
        restriction_closed_to_arrival:    'Closed to arrival',
        restriction_closed_to_departure:  'Closed to departure',
        restriction_max_stay:             'Maximum nights',
        restriction_min_advance_booking:  'Minimum days in advance',
        restriction_min_stay:             'Minimum nights',
        restriction_stop_sell:            'Stop sell',
        restrictions:                     'Bulk restrictions',
        restrictions_form_hint:           'One window of selling rules over every property in scope.',
        restrictions_hint:                'The default restrictions a push writes together with the prices.',
        saved:                            'Template {code} was saved',
        subtitle:                         'what the group charges and what the properties sell',
        tab_categories:                   'Categories',
        tab_parity:                       'Parity',
        tab_restrictions:                 'Restrictions',
        tab_templates:                    'Templates',
        target_ok:                        'written',
        templates:                        'Rate templates',
        templates_hint:                   'The decisions of the group. Nothing reaches a property until a push.',
        tile_deviations:                  'Price deviations',
        tile_deviations_hint:             'plans selling at another price',
        tile_houses:                      'Properties',
        tile_houses_hint:                 'in scope',
        tile_linked_plans:                'Plans from templates',
        tile_linked_plans_hint:           'linked plans across the properties',
        tile_overridden:                  'Overridden',
        tile_overridden_hint:             'plans a property changed itself',
        tile_stale:                       'Stale',
        tile_stale_hint:                  'plans on an older version',
        title:                            'Rates',
        type_derived:                     'Derived',
        type_standard:                    'Standard',
        unmapped_room_type:               '{code} — no category',
        unreadable:                       'These properties could not be read',
        version_badge:                    'v{version}',
        version_current:                  'current',
        version_stale:                    'stale — {version} of {current}',
        write:                            'Write to the properties',
    },
    master_groups: {
        add:                   'New master group',
        adults:                'Adults',
        arrival:               'Arrival',
        back:                  'Back',
        block_add:             'Add room type',
        board_hint:            'Agreed, held, picked up and released, by house and by room type. The buttons on a row act in that house.',
        board_title:           'Pickup by house',
        cancel_hint:           'Cancelling a master group cancels the group in every house through that house’s own cancellation, which prices the ladder and releases the rooms.',
        cell_state:            'Agreed {rooms} · held {held} · picked up {picked} · released {released}',
        children:              'Children',
        column_company:        'Client',
        column_held:           'Held',
        column_house:          'House',
        column_houses:         'Houses',
        column_ladder:         'Ladder',
        column_link:           'Link',
        column_name:           'Name',
        column_number:         'Number',
        column_pending:        'Pending',
        column_period:         'Period',
        column_picked_up:      'Picked up',
        column_price:          'Price / night',
        column_released:       'Released',
        column_rooms:          'Agreed',
        column_status:         'Status',
        company:               'Client',
        company_help:          'The firm that orders the congress. Copied into every house as the payer of its group.',
        company_placeholder:   'Find a company',
        contact_email:         'E-mail',
        contact_name:          'Contact',
        contact_phone:         'Telephone',
        contract_hint:         'The payer, the dates and the cancellation ladder are the contract’s: a house can no longer change them on its own (code 126). The head office changes them here and they propagate.',
        contract_title:        'Contract',
        create:                'Create',
        created:               'Master group {number} created',
        created_partly:        'The master group was created; {count} houses did not take it',
        departure:             'Departure',
        from:                  'Arriving from',
        house_unreadable:      'The house {house} could not be read',
        ladder_add:            'Add tier',
        ladder_days:           'Days before arrival',
        ladder_differs:        'out of step',
        ladder_hint:           'The first tier the notice reaches applies. Tiers must run from the longest notice down.',
        ladder_keep:           'Charged (%)',
        ladder_matches:        'in step',
        ladder_order:          'Tiers must fall: each one has fewer days before arrival than the one above it.',
        ladder_title:          'Cancellation ladder',
        legend_board:          'Picked up is agreed minus held minus released.',
        legend_price:          'The price is the block’s agreed snapshot in the house’s currency and is never converted.',
        legend_rooming:        'The rooming link belongs to the house: the head office sees them, the hotel’s own desk issues them.',
        legend_rooms:          'A tinted row: in at least one house no group was created.',
        legend_sync:           'Tinted row: the house does not hold the congress\'s release date or cancellation ladder.',
        legend_unmade:         'A warning-coloured badge means no group was created in that house.',
        link_none:             'No link',
        link_open:             'Issued',
        member_add:            'Add a house',
        member_add_help:       'A house of the scope. It is given a group with the master group’s dates, payer and ladder.',
        member_failed:         'The house {house} did not take the press',
        member_pick:           'Pick a house …',
        member_remove:         'Remove house',
        member_unmade:         'No group was created in this house',
        members_hint:          'Every house gets its own group, with its own number and its own blocks.',
        members_title:         'Houses and blocks',
        move_cancel:           'Cancel',
        move_cancel_confirm:   'Cancel the master group and the group in {count} houses? Each house prices its own cancellation ladder and releases the rooms.',
        move_complete:         'Complete',
        move_complete_confirm: 'Complete the master group and the group in {count} houses?',
        move_confirm:          'Confirm',
        move_confirm_confirm:  'Confirm the master group and the group in {count} houses?',
        move_failed:           'The status could not be changed',
        move_option:           'To option',
        move_option_confirm:   'Put the master group on option in {count} houses? The houses will take the rooms.',
        moved:                 'The status is now “{status}”',
        moved_partly:          'The status was changed; {count} houses did not follow',
        name:                  'Name',
        name_help:             'The congress’s name. Every house gets it on its own group, so its desk recognises it on its own list.',
        name_placeholder:      'SDZP Congress 2026',
        new_hint:              'One contract, and one group in every house it names.',
        new_title:             'New master group',
        nightly_price:         'Price / night',
        nightly_price_help:    'The agreed price per room per night, in that house’s currency.',
        no_company:            'No client',
        no_houses:             'No houses',
        no_room_types:         'This house has no room types',
        no_rows:               'No master groups',
        notes:                 'Notes',
        open_reception:        'Open in reception',
        open_reception_hint:   'Opens this house’s group in its own reception: the rooming list, the offer, the folio and a single room are all there.',
        pickup_do:             'Pick up',
        pickup_failed:         'The pickup could not be made',
        pickup_payer_hint:     'The rooms are picked up onto the group’s client. A room with a guest’s name on it is picked up by the desk that has the guest.',
        pickup_rooms_help:     'How many held rooms should become reservations. Each room is an act of its own.',
        pickup_title:          'Pick up rooms',
        release_date:          'Release date',
        release_date_help:     'When unclaimed rooms go back on sale by themselves. Propagated to every house.',
        release_do:            'Release',
        release_failed:        'The release could not be made',
        release_rooms_help:    'How many held rooms should go back on sale. The agreed count does not move.',
        release_title:         'Release rooms',
        resync:                'Resync',
        resync_confirm:        'Write the congress\'s release date and cancellation ladder into {count} houses again?',
        resync_failed:         'The resync could not be run',
        resync_hint:           'Writes the contractual parts of the congress into the houses that did not take them. The contract itself is unchanged.',
        resync_one:            'Resync',
        resynced:              'The houses are in step with the congress contract',
        resynced_partly:       'The resync ran, {count} houses did not take it',
        room_type:             'Room type',
        rooming_hint:          'One link per house and not one for the congress: which house a name belongs in is known only by the house that receives it.',
        rooming_open_hint:     'Opens this house’s group in its own reception, where the rooming list is issued and settled.',
        rooming_title:         'Rooming lists',
        rooms:                 'Rooms',
        rooms_done:            'Done: {done} of {asked}',
        status:                'Status',
        status_all:            'All statuses',
        status_cancelled:      'Cancelled',
        status_completed:      'Completed',
        status_confirmed:      'Confirmed',
        status_inquiry:        'Inquiry',
        status_option:         'Option',
        subtitle:              'One congress across several houses',
        sync_drifted:          'Houses out of step: {count}',
        sync_hint:             'The contract is propagated house by house: a hotel that was unreachable then still holds the old one. This says which.',
        sync_master_date:      'congress: {date}',
        sync_title:            'Contract by house',
        table_hint:            'One row is one contract. A click opens the congress.',
        table_title:           'Master groups',
        tile_held:             'Rooms held',
        tile_held_hint:        'Real room-nights in the houses, not a forecast.',
        tile_houses:           'Houses',
        tile_picked_up:        'Rooms picked up',
        tile_picked_up_hint:   'Agreed minus held minus released.',
        tile_rooms:            'Rooms agreed',
        tile_rooms_hint:       'The sum of the blocks across every house of the congress.',
        title:                 'Master groups',
        to:                    'Arriving until',
        total_row:             'Total ({count} houses)',
    },

    reservations: {
        adults:                  'Adults',
        arrival:                 'Arrival',
        book:                    'Book',
        booked:                  'Reservation {number} created',
        category:                'Category',
        category_help:           'The category or the room type code, e.g. DBL. Empty means every type.',
        category_placeholder:    'DBL',
        cell_tooltip:            'In the property’s currency: {price} · rate plan: {plan}',
        children:                'Children',
        departure:               'Departure',
        column_amount:           'Amount',
        column_company:          'Company',
        column_house:            'Property',
        column_last_stay:        'Last stay',
        column_nights:           'Nights',
        column_open:             'Outstanding',
        column_room_types:       'Room types',
        column_spend:            'Spend',
        column_stays:            'Stays',
        company:                 'Company',
        company_help:            'The firm that pays for the room. Searched by name or tax number.',
        company_placeholder:     'Find a company',
        cross_company:           'The two properties belong to different companies',
        cross_company_hint:      'A transfer between companies is not a move: it is a cancellation in one set of books and a new sale in the other. The reason is written into both properties’ audit trails.',
        cross_company_confirm:   'I understand this is a cancellation in one company and a new sale in the other',
        errors_hint:             'These properties are not in the answer.',
        errors_title:            'Properties that could not be read',
        find:                    'Find',
        find_hint:               'A reservation is found by its property and the exact number on the guest’s confirmation.',
        find_title:              'Find a reservation',
        found_title:             'Reservation found',
        from_house:              'From property',
        grid_hint:               'Free means free for the WHOLE stay ({nights} nights), not for a single date. Click a room type to open a new reservation.',
        grid_title:              'Availability by property',
        guest:                   'Guest',
        guest_help:              'The guest who pays for the room. Searched by surname.',
        guest_placeholder:       'Find a guest',
        guest_search_hint:       'One person across every property of the group: how much they have stayed, spent, and still owe.',
        guest_search_title:      'Find a guest',
        guest_unknown:           'No property in scope has met this guest',
        houses_hint:             'Only the properties that know this guest. A tinted row: the month has no exchange rate, so its spend is out of the group total.',
        houses_title:            'By property',
        legend_free:             'The figure beside a room type is rooms free for the whole stay.',
        legend_fx:               'The total spend is converted at the current month’s rate.',
        legend_houses:           'Outstanding amounts stay in the currency the property is owed in.',
        legend_no_rate:          'Where the month has no rate, the property’s own price is shown in its own currency.',
        move:                    'Transfer',
        move_failed:             'The transfer could not be made',
        move_half_done:          'The new reservation was created and the original could NOT be cancelled. The guest holds a room in both properties — cancel the original by hand.',
        move_hint:               'The new reservation is made in the receiving property on its own rate plan; the original is cancelled. Deposits and invoices stay with the original property.',
        move_title:              'Transfer to another property',
        moved:                   'Transferred. New reservation: {number}',
        new_title:               'New reservation',
        no_company:              'No company',
        no_plan:                 'no rate plan',
        no_room_types:           'This property has no room types',
        no_rows:                 'No property in scope answered',
        not_found:               'No reservation with that number in this property',
        not_movable:             'This reservation cannot be transferred',
        not_movable_hint:        'A draft or a confirmed reservation can be transferred. A checked-in guest is moved by the desk holding their key.',
        not_priced:              'no price',
        not_priced_hint:         'The property cannot quote this stay — no rate plan, or no rate on one of the nights.',
        notes:                   'Note',
        number:                  'Reservation number',
        number_placeholder:      'R-20261012-0007',
        open_in_reception:       'Open in reception',
        payer:                   'Payer',
        payer_company:           'Company',
        payer_guest:             'Guest',
        per_period:              'Free means free for the whole stay, not for a single date.',
        pick_house:              'Pick a property',
        pick_room_type:          'Pick a room type',
        reason:                  'Reason',
        reason_help:             'Written into both properties’ audit trails.',
        reason_required:         'Required for a transfer between companies.',
        room_type:               'Room type',
        room_type_help:          'Only the types free in the receiving property for these dates are offered.',
        search:                  'Search',
        search_hint:             'One stay, every property in scope. The price is for the whole stay.',
        search_title:            'Search',
        source:                  'Source',
        source_agency:           'Agency',
        source_corporate:        'Corporate',
        source_email:            'E-mail',
        source_phone:            'Telephone',
        stay:                    'Stay',
        stays_hint:              'Every stay of this person in the group, newest first.',
        stays_title:             'Stays',
        status:                  'Status',
        status_cancelled:        'Cancelled',
        status_checked_in:       'Checked in',
        status_checked_out:      'Checked out',
        status_confirmed:        'Confirmed',
        status_draft:            'Draft',
        status_no_show:          'No show',
        subtitle:                'central reservations and guest 360',
        tab_availability:        'Availability',
        tab_guest:               'Guest 360',
        tab_transfer:            'Transfer',
        tile_nights:             'Nights',
        tile_open:               'Outstanding',
        tile_open_hint:          'by the currency each property is owed in',
        tile_spend:              'Spend',
        tile_spend_excluded:     'without {count} properties with no rate',
        tile_stays:              'Stays',
        tile_stays_hint:         'properties that know the guest: {houses}',
        title:                   'Reservations',
        to_house:                'To property',
    },
    roi: {
        column_bookings:       'Bookings',
        column_clicks:         'Clicks',
        column_cost:           'Cost',
        column_guest:          'Guest',
        column_guest_bookings: 'Bookings',
        column_guest_first:    'First stay in',
        column_guest_houses:   'Houses',
        column_guest_spend:    'Spend across houses',
        column_guest_stays:    'Stays',
        column_new_guests:     'New',
        column_paid:           'Paid',
        column_realised:       'Realised',
        column_roi:            'ROI',
        column_row:            'Campaign',
        column_started:        'Started',
        column_value:          'Value',
        column_visits:         'Visits',
        errors_hint:           'These houses did not answer; their figures are not in the table.',
        errors_title:          'Houses that did not answer',
        excluded_hint:         'These houses have no rate for the month the campaign went out — the counts stand, the money does not.',
        excluded_title:        'Houses without money',
        from:                  'From',
        group_by:              'Group by',
        group_campaign:        'By campaign',
        group_channel:         'By channel',
        group_house:           'By house',
        guest_new:             'first time with us',
        guests_hint:           'Spend and stays are the GUEST\'s across every house of the group, not what they spent on this campaign.',
        guests_subtitle:       'guests of „{name}“',
        guests_title:          'Guests',
        houses_count:          'houses: {count}',
        legend_capped:         'The first 200 rows are shown; narrow it with the search box.',
        legend_guest_value:    'Spend is the guest\'s across every house in scope, from the „Guest 360“ profile.',
        legend_guests_capped:  'The first {count} guests are shown.',
        legend_rate:           'Money is converted at the rate of the month the campaign went out.',
        legend_window:         'The window selects bookings by the day they were made; the money that follows them is counted in full.',
        lost_short:            'cancelled and no-shows: {count}',
        nights_short:          'nights: {nights}',
        no_data:               'No campaigns in this window.',
        no_guests:             'No guest paid for this campaign.',
        no_rate_short:         'a house has no rate',
        open_guests:           'Guests',
        search:                'Search a campaign, channel or house',
        status_no_rate:        'no rate for {month}',
        subtitle:              'what paid off across the houses',
        table_by_campaign:     'By campaign',
        table_by_channel:      'By channel',
        table_by_house:        'By house',
        table_hint:            'Expand a row to see the houses that make it up — each in its own currency.',
        tile_bookings:         'Bookings',
        tile_bookings_hint:    'cancelled and no-shows: {cancelled}',
        tile_cost:             'Cost',
        tile_cost_hint:        'houses in scope: {count}',
        tile_cpa:              'Cost per booking',
        tile_cpa_hint:         'spend per booking won',
        tile_new_guests:       'New guests',
        tile_new_guests_hint:  'payers with no stay before the window',
        tile_new_guests_unknown: 'too many payers to count',
        tile_return:           'Returned',
        tile_return_invoiced:  'from invoices issued — the money is not in yet',
        tile_return_paid:      'from payments received',
        tile_roi:              'ROI',
        tile_roi_hint:         '0 % is break-even',
        tile_roi_unknown:      'no cost entered',
        title:                 'ROI',
        to:                    'To',
        total_row:             'Total ({campaigns} campaigns, {houses} houses)',
    },
    campaign: {
        any_status:                'All statuses',
        audience_count:            'Recipients',
        audience_duplicate:        'Duplicate addresses',
        audience_hint:             'Resolved now. It is resolved again at the send, so a guest who withdrew consent this morning is not written to this afternoon.',
        audience_house:            'House',
        audience_no_consent:       'Without consent or an address',
        audience_no_stay:          'Without a stay in scope',
        audience_sample:           'Examples',
        audience_suppressed_group: 'On the group suppression list',
        audience_suppressed_house: 'On a house suppression list',
        audience_title:            'Audience preview',
        audience_total:            'Recipients in total',
        budget:                    'Budget',
        cancel:                    'Cancel campaign',
        cancel_confirm:            'Cancel the campaign “{name}”? This does not undo letters already sent.',
        cancelled:                 'The campaign “{name}” has been cancelled',
        channel_email:             'E-mail',
        channel_gbp:               'Google Business',
        channel_seo:               'SEO',
        channel_social:            'Social',
        children_title:            'By house',
        column_actions:            'Actions',
        column_at:                 'When',
        column_bookings:           'Bookings',
        column_channel:            'Channel',
        column_child_status:       'Outcome',
        column_cost:               'Cost',
        column_currency:           'Currency',
        column_email:              'Address',
        column_failed:             'Failed',
        column_funnel_status:      'Conversion',
        column_house:              'House',
        column_houses:             'Houses',
        column_language:           'Language',
        column_message:            'Note',
        column_name:               'Campaign',
        column_note:               'Note',
        column_paid:               'Paid',
        column_reason:             'Reason',
        column_recipients:         'Recipients',
        column_scheduled:          'Scheduled',
        column_sent:               'Sent',
        column_source:             'Origin',
        column_source_house:       'Source',
        column_status:             'Status',
        column_template:           'Template',
        column_value:              'Value',
        column_version:            'Version',
        cost:                      'Cost',
        cost_hint:                 'In the group reporting currency. Entered by hand, and editable after the send.',
        created:                   'The campaign “{name}” has been created',
        dedupe:                    'One guest, one mail',
        dedupe_hint:               'Two profiles sharing an address are one person. The house of the later stay writes.',
        dedupe_off:                'Off',
        dedupe_on:                 'On',
        delete_confirm:            'Delete the draft campaign “{name}”?',
        deleted:                   'The campaign “{name}” has been deleted',
        dialog_edit:               'Edit campaign',
        dialog_hint:               'A campaign is one decision and as many sends as there are houses in scope.',
        dialog_new:                'New campaign',
        dpo_confirmed:             'The footer text has been confirmed by the data protection officer',
        dpo_confirmed_hint:        'An unconfirmed footer does not block a send — it is recorded in the audit trail.',
        dpo_pending:               'The footer text has not been confirmed yet (DPO)',
        drawer_title:              'Campaign',
        excluded_hint:             'The total leaves out {count} houses: {houses}',
        filter_status:             'Status',
        footer_en:                 'Footer (English)',
        footer_hint:               'Appended to every group letter. It says the sender is the group, and which hotels the unsubscribe covers.',
        footer_placeholders:       'Use {group} for the group name and {houses} for the list of hotels.',
        footer_sl:                 'Footer (Slovenian)',
        footer_title:              'Group letter footer',
        funnel_from:               'From',
        funnel_title:              'Funnel and return',
        funnel_to:                 'To',
        handle:                    'Key',
        houses:                    'Houses',
        houses_all:                'The whole scope at the send',
        houses_hint:               'Empty means the whole scope of the account that presses Send.',
        language_fallback:         'Fallback language',
        language_fallback_hint:    'The language a house is written in where the brand has nothing in its own.',
        name:                      'Name',
        new:                       'New campaign',
        no_campaigns:              'No campaigns',
        no_suppressions:           'The list is empty',
        no_templates:              'No templates',
        owner:                     'Owner',
        preview:                   'Refresh preview',
        preview_hint:              'The preview writes nothing and sends nothing.',
        reason_bounce:             'Bounce',
        reason_complaint:          'Complaint',
        reason_manual:             'Manual',
        reason_unsubscribed:       'Unsubscribed',
        roi_unknown:               'No cost, no return',
        saved:                     'The campaign “{name}” has been saved',
        scheduled_at:              'Scheduled',
        scheduled_hint:            'Empty means somebody presses the button.',
        segment_all_consented:     'Everybody with consent who has ever stayed',
        segment_kind:              'Audience',
        segment_last_stay_window:  'Last stay within a window',
        send:                      'Send',
        send_confirm:              'Send the campaign “{name}” to {count} recipients out of {houses} houses? Letters cannot be recalled.',
        send_test:                 'Send a test',
        send_test_hint:            'One letter to one address, out of the group sending house. It records nothing.',
        send_test_title:           'Test letter',
        sent:                      'The campaign “{name}” has been sent',
        settings_saved:            'The settings have been saved',
        status_cancelled:          'Cancelled',
        status_draft:              'Draft',
        status_scheduled:          'Scheduled',
        status_sending:            'Sending',
        status_sent:               'Sent',
        subtitle:                  'group campaigns and brand templates',
        suppression_add:           'Add an address',
        suppression_added:         'The address is on the group list',
        suppression_dialog_hint:   'An address no house of the group will write to again.',
        suppression_dialog_title:  'New address on the list',
        suppression_email:         'Address',
        suppression_locked:        'An unsubscribe is undone by nobody but the guest',
        suppression_note:          'Note',
        suppression_reason:        'Reason',
        suppression_remove_confirm: 'Remove this address from the group suppression list?',
        suppression_removed:       'The address has been removed from the list',
        suppression_search:        'Search by address',
        tab_campaigns:             'Campaigns',
        tab_footer:                'Footer and settings',
        tab_suppressions:          'Exclusions',
        tab_templates:             'Templates',
        template:                  'Template',
        template_active:           'Offered',
        template_active_no:        'Withdrawn',
        template_active_yes:       'Offered',
        template_body:             'Body',
        template_channel:          'Channel',
        template_created:          'The template “{name}” has been created',
        template_delete_confirm:   'Delete the template “{name}”?',
        template_deleted:          'The template “{name}” has been deleted',
        template_dialog_edit:      'Edit template',
        template_dialog_hint:      'A template belongs to a unit and is inherited by every unit below it.',
        template_dialog_new:       'New template',
        template_hint:             'Inherited templates are marked.',
        template_inherited:        'Inherited',
        template_inherited_from:   'Inherited from: {unit}',
        template_language:         'Language',
        template_name:             'Name',
        template_new:              'New template',
        template_saved:            'The template “{name}” has been saved',
        template_title:            'Title',
        test_address:              'Test address',
        test_sent:                 'The test letter has been sent',
        tile_bookings:             'Bookings',
        tile_cost:                 'Cost',
        tile_return:               'Return',
        tile_roi:                  'ROI',
        title:                     'Campaigns',
        total_recipients:          'Recipients in total',
        totals:                    'Group',
        unit:                      'Unit',
        unit_all:                  'All units',
        window_from:               'Stayed from',
        window_to:                 'Stayed to',
    },
}
